import React from 'react'
import cn from 'classnames'
import Accordion from './Accordion'
import { single } from './shared'

const SinglePreventCloseAccordion = ({ items, topLine, small, ...props }) => (
  <Accordion stateReducer={single} {...props}>
    {({ openIndexes, handleItemClick }) => (
      <div
        className={cn('c-accordion', {
          'c-accordion--top-line': topLine,
          'c-accordion--small': small,
        })}
      >
        {items.map((item, index) => (
          <div
            key={item.title}
            className={cn('c-accordion__item', {
              'is-open': openIndexes.indexOf(index) >= 0,
            })}
          >
            <div
              className="c-accordion__btn t-h2"
              onClick={() => handleItemClick(index)}
            >
              {item.title}
            </div>
            <div className="c-accordion__contents">{item.contents}</div>
          </div>
        ))}
      </div>
    )}
  </Accordion>
)

export { SinglePreventCloseAccordion }



// WEBPACK FOOTER //
// ./src/components/Accordion/SinglePreventCloseAccordion.js